<template>
  <section>
    <button class="btn btn-info btn-block"
            @click="openUpdateServiceDateTimeModal()"
            v-if="displaySection()">
      {{ $t('message.button.select_service_datetime') }}
    </button>
    <!-- Update Service Date-Time Modal -->
    <select-service-date-time-modal ref="selectServiceDateTimeModal" :order="order" />
  </section>
</template>

<script>
  import SelectServiceDateTimeModal from './SelectServiceDateTimeModal'

  export default {
    props: ['order'],
    components: {
      SelectServiceDateTimeModal
    },
    methods: {
      displaySection () {
        return (this.order.paid_status === 1 && this.order.is_no_datetime_booking === 1 && this.order.status === 0)
      },
      openUpdateServiceDateTimeModal () {
        this.$refs.selectServiceDateTimeModal.showModal(true)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/SelectServiceDateTimeSection.vue